module.exports = __webpack_public_path__ + "img/grigoris-pappas.7fd7ae5b.png";